(() => {
  const storageKey = 'fluffyslip-recently-viewed-v1';

  const readHistory = () => {
    try {
      if (!window.localStorage) throw new Error('Storage unavailable');
      const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value : [];
    } catch {
      try {
        if (window.name?.startsWith(`${storageKey}:`)) {
          const value = JSON.parse(decodeURIComponent(window.name.slice(storageKey.length + 1)));
          if (Array.isArray(value)) return value;
        }
      } catch {
        // Continue to the cookie fallback.
      }

      try {
        const cookie = String(document.cookie || '')
          .split('; ')
          .find((entry) => entry.startsWith(`${storageKey}=`));
        if (!cookie) return [];
        const value = JSON.parse(decodeURIComponent(cookie.split('=').slice(1).join('=')));
        return Array.isArray(value) ? value : [];
      } catch {
        return [];
      }
    }
  };

  const saveHistory = (products) => {
    const history = products.slice(0, 8);
    try {
      window.localStorage?.setItem(storageKey, JSON.stringify(history));
      if (window.localStorage) return;
    } catch {
      // Fall through to tab and cookie storage.
    }

    const compactHistory = JSON.stringify(history.slice(0, 4));
    try {
      window.name = `${storageKey}:${encodeURIComponent(compactHistory)}`;
    } catch {
      // Continue to the cookie fallback.
    }

    try {
      document.cookie = `${storageKey}=${encodeURIComponent(
        compactHistory
      )}; path=/; max-age=2592000; SameSite=Lax`;
    } catch {
      // Browsing remains fully functional when every storage mode is unavailable.
    }
  };

  const buildCard = (product) => {
    const item = document.createElement('li');
    item.className = 'fluffyslip-recently-viewed__item';

    const link = document.createElement('a');
    link.className = 'fluffyslip-recently-viewed__link';
    link.href = product.url;

    if (product.image) {
      const image = document.createElement('img');
      image.className = 'fluffyslip-recently-viewed__image';
      image.src = product.image;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 720;
      image.height = 720;
      link.append(image);
    }

    const details = document.createElement('span');
    details.className = 'fluffyslip-recently-viewed__details';

    if (product.vendor) {
      const vendor = document.createElement('span');
      vendor.className = 'fluffyslip-recently-viewed__vendor';
      vendor.textContent = product.vendor;
      details.append(vendor);
    }

    const title = document.createElement('span');
    title.className = 'fluffyslip-recently-viewed__title';
    title.textContent = product.title;
    details.append(title);

    const price = document.createElement('span');
    price.className = 'fluffyslip-recently-viewed__price';
    price.textContent = product.price;
    details.append(price);

    link.append(details);
    item.append(link);
    return item;
  };

  document.querySelectorAll('[data-fluffyslip-recently-viewed]').forEach((section) => {
    const data = section.querySelector('[data-current-product]');
    const list = section.querySelector('[data-recently-viewed-list]');
    if (!data || !list) return;

    let current;
    try {
      current = JSON.parse(data.textContent);
    } catch {
      return;
    }

    const history = readHistory().filter(
      (item) => item && item.id && item.id !== current.id && item.title && item.url
    );
    const limit = Math.max(1, Number(section.dataset.limit) || 4);
    history.slice(0, limit).forEach((product) => list.append(buildCard(product)));

    if (list.children.length) section.hidden = false;
    saveHistory([current, ...history.filter((item) => item.id !== current.id)]);
  });
})();
